module.exports = __webpack_public_path__ + "img/Team-Wilde-Pracht-680.2abe08b8.jpg";